import { render, staticRenderFns } from "./SelfieStream.vue?vue&type=template&id=1bad4861"
import script from "./SelfieStream.vue?vue&type=script&lang=js"
export * from "./SelfieStream.vue?vue&type=script&lang=js"
import style0 from "./SelfieStream.vue?vue&type=style&index=0&id=1bad4861&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports